export default "__VITE_ASSET__usbwCE43__"